import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2021-11-05T12:00",
		title: `
<h4>しばた地域医療介護連携センターより</h4>
<p class="paragraph-indent">
●医療介護関係者の研修会　新型コロナウイルスの現状とワクチンについて&訪問系サービスの取り組み報告のご案内<br>
・<a href="${topicsDir}/2021/11-covid-workshop.pdf">案内チラシ、申込書</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	},
	{
		date: "2021-11-09T12:00",
		title: `
<h4>新潟県医師会在宅医療推進センターより</h4>
<p class="paragraph-indent">
●「第13回在宅ケアを考える集いin越後2021」を11月3日（水・祝）に開催いたしました。<br>
YouTubeにてライブ配信した動画を公開しています。<br>
・<a href="https://www.youtube.com/watch?v=LPtdlfSXIH4">動画URL</a>
・<a href="${topicsDir}/2021/11-13thzaitaku-care.pdf">抄録集PDF</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
